// extracted by mini-css-extract-plugin
export var body = "contact-us-module--body--1af8a";
export var box = "contact-us-module--box--cda4e";
export var boxes = "contact-us-module--boxes--e6484";
export var contactInfo = "contact-us-module--contactInfo--c2964";
export var container = "contact-us-module--container--24045";
export var description = "contact-us-module--description--d7dfe";
export var header = "contact-us-module--header--3ce89";
export var icon = "contact-us-module--icon--bde3c";
export var title = "contact-us-module--title--34002";